import { axiosInstance } from "@/lib/axios-instance";

interface OpportunityStatsResponse {
  status: string;
  data: {
    total: number;      // Total number of applications for the opportunity
    tracked: number;    // Number of AI-tracked applications
    maxLimit: number;   // Company's subscription deal limit
  };
}

export const getOpportunityStats = async (
  opportunityId: string
): Promise<OpportunityStatsResponse> => {
  const response = await axiosInstance.get(
    `/get_opportunity_stats?opportunity_id=${opportunityId}`
  );
  return response.data;
};